import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";
import log from "loglevel";

export const initState = {
    list: [],
    listStatus: ACTION_STATES.NO_REQUEST,
    filterList: [],
    queryParams: {
        showArchived: false,
    },
    searchQ: null,
};

export class LOAD_LIST extends ComplexAction {
    sendRdx(state) {
        return Object.assign({}, state, {
            listStatus: ACTION_STATES.SEND,
        });
    }

    successRdx(state, { payload }) {
        log.debug("payload", payload);
        return {
            ...state,
            list: payload.users,
            filterList: payload.users,
            listStatus: ACTION_STATES.SUCCESS,
        };
    }
}

export class ON_SEARCH extends ComplexAction {
    sendRdx(state, { payload }) {
        return Object.assign({}, state, { searchQ: payload });
    }

    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            filterList: payload,
        });
    }
}

export class ON_CHANGE_SEARCH_FORM extends DefaultAction {
    callRdx(state, { payload }) {
        return {
            ...state,
            queryParams: {
                ...state.queryParams,
                ...payload,
            },
        };
    }
}

export const actions = {
    LOAD_LIST: new LOAD_LIST(),
    ON_SEARCH: new ON_SEARCH(),
    ON_CHANGE_SEARCH_FORM: new ON_CHANGE_SEARCH_FORM(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);

export const searchQSelector = (state) => state.users.searchQ;
export const listSelector = (state) => state.users.list;
export const queryParamSelector = (state) => state.users.queryParams;
